import { SvgIcon } from "@mui/material";
import React from "react";

export default function CampaignIcon({ fill, ...props }: any) {
  return (
    <SvgIcon
      width="148"
      height="50"
      viewBox="0 0 148 50"
      fill={fill}
      stroke={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.7799 8.89121H21.5598V10.6637C21.5598 10.9118 21.8434 11.0891 22.0561 10.9827L25.8847 8.89121H29.6424C30.3159 8.89121 30.8477 8.35946 30.8477 7.68591V1.58854C30.8477 0.914988 30.3159 0.38324 29.6424 0.38324H20.7799C20.1418 0.38324 19.6101 0.914988 19.6101 1.58854V7.72136C19.6101 8.35946 20.1418 8.89121 20.7799 8.89121ZM25.1757 4.99172C24.4667 4.99172 23.9349 4.42452 23.9349 3.75098C23.9349 3.18378 24.3249 2.68748 24.8566 2.54568V2.47478C24.8566 2.29753 24.9984 2.12028 25.2111 2.12028C25.3884 2.12028 25.5656 2.26208 25.5656 2.47478V2.51023C26.0974 2.65203 26.4873 3.14833 26.4873 3.71553C26.4873 3.89278 26.3455 4.07003 26.1328 4.07003C25.9556 4.07003 25.7783 3.92823 25.7783 3.71553C25.7783 3.39648 25.5302 3.14833 25.2111 3.14833C24.8921 3.14833 24.6439 3.39648 24.6439 3.71553C24.6439 4.03458 24.8921 4.28272 25.2111 4.28272C25.9201 4.28272 26.4519 4.84992 26.4519 5.55892C26.4519 6.12612 26.0619 6.62242 25.5302 6.76421V6.79967C25.5302 6.97691 25.3884 7.15416 25.1757 7.15416C24.9984 7.15416 24.8212 7.01236 24.8212 6.79967V6.76421C24.2894 6.62242 23.8995 6.12612 23.8995 5.55892C23.8995 5.38167 24.0413 5.20442 24.254 5.20442C24.4667 5.20442 24.6085 5.34622 24.6085 5.55892C24.6085 5.87797 24.8566 6.12612 25.1757 6.12612C25.4947 6.12612 25.7429 5.87797 25.7429 5.55892C25.7429 5.23987 25.4947 4.99172 25.1757 4.99172Z"
          //   fill="#A6A6A6"
          fill={fill}
        />
        <path
          d="M6.81862 14.8494L1.85038 17.9068C0.856728 18.5183 0.550991 19.8177 1.16247 20.8113L3.60837 24.8623C3.99054 25.4738 4.67846 25.856 5.36637 25.856C5.74854 25.856 6.13071 25.7796 6.43645 25.5503H6.51288L8.27088 28.4548C8.95879 29.6013 10.411 29.9835 11.634 29.2191C12.7805 28.5312 13.1627 27.0025 12.3983 25.856L10.7168 22.875L11.4811 22.4164L6.81862 14.8494Z"
          fill={fill}
        />
        <path
          d="M20.0418 11.7156C19.201 10.3398 17.5195 9.72831 15.9908 10.2634L14.0035 6.97667C13.6977 6.44163 12.7805 6.51806 12.6276 7.20597C11.9397 9.95761 10.3346 12.4035 8.04157 14.0086L12.7805 21.6521C15.2264 20.3527 18.2074 19.9705 20.959 20.582C21.5705 20.7349 22.1055 20.047 21.7234 19.5119L19.5068 15.9959C20.6533 14.8494 20.959 13.0914 20.0418 11.7156Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
}
